(function () {
  function createCookie(name, value, minutes) {
    var expires;

    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      expires +
      "; path=/";
  }

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name, "", -1);
  }

  const headerHandlers = () => {
    const $header = document.querySelector("#shopify-section-header");
    const $dropdownItems = document.querySelectorAll(
      "#shopify-section-header .nav-item.has-dropdown"
    );
    const isCollectionPage = location.pathname
      .split("/")
      .includes("collections");
    const scrollThreshold = isCollectionPage ? 25 : 50;

    function handleMouseEnter(event) {
      let $item = event.currentTarget;
      $header.classList.add("scrolled");
    }

    function handleMouseLeave(event) {
      let top = window.scrollY;
      if (top < 100) {
        $header.classList.remove("scrolled");
      }
    }

    [...$dropdownItems].forEach(function ($item) {
      $item.addEventListener("mouseenter", handleMouseEnter);
      $item.addEventListener("mouseleave", handleMouseLeave);
    });

    window.addEventListener(
      "scroll",
      function (event) {
        var top = this.scrollY,
          left = this.scrollX;

        if (top > scrollThreshold) {
          $header.classList.add("scrolled");
        } else {
          if (!$header.matches(":hover")) {
            $header.classList.remove("scrolled");
          } else {
            function handleLeave() {
              $header.classList.remove("scrolled");
              $header.removeEventListener("mouseleave", handleLeave);
            }

            $header.addEventListener("mouseleave", handleLeave);
          }
        }
      },
      false
    );
  };

  /**
   * Nosto attribution for a product added to cart after a recommendation click.
   *
   * Nosto records the VP itself when a recommendation link is clicked, but the ref dies
   * with the navigation -- so the add-to-cart on the destination PDP has nothing to hang
   * a CP on, which is the gap Nosto flagged (Ben Bradley, 2026-08-20). Stash the campaign
   * id against the product handle on the click, then spend it on the next /cart/add.js
   * for that same product.
   */
  const NOSTO_CLICK_REF_KEY = "wip:nosto:clickRef";
  const NOSTO_CLICK_REF_TTL = 30 * 60 * 1000;

  const nostoAttribution = () => {
    // Nosto stamps the placement it rendered with data-nosto-ref, carrying the campaign
    // id either as JSON ({"ref":"productpage-nosto-7"}) or as a bare string.
    function campaignRef($placement) {
      const raw = $placement.getAttribute("data-nosto-ref");

      if (!raw) return null;

      try {
        const parsed = JSON.parse(raw);
        return (parsed && parsed.ref) || null;
      } catch (error) {
        return raw;
      }
    }

    function productHandle(url) {
      const match = String(url).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }

    function readClickRef() {
      try {
        const stored = JSON.parse(sessionStorage.getItem(NOSTO_CLICK_REF_KEY));

        if (!stored || !stored.ref || !stored.handle) return null;
        if (Date.now() - stored.ts > NOSTO_CLICK_REF_TTL) return null;

        return stored;
      } catch (error) {
        return null;
      }
    }

    function clearClickRef() {
      try {
        sessionStorage.removeItem(NOSTO_CLICK_REF_KEY);
      } catch (error) {
        // Nothing to clear.
      }
    }

    function addedLine(xhr) {
      let payload = xhr && xhr.responseJSON;

      if (!payload && xhr && xhr.responseText) {
        try {
          payload = JSON.parse(xhr.responseText);
        } catch (error) {
          return null;
        }
      }

      if (!payload) return null;

      // A single add returns the line item itself, a multi-add returns { items: [...] }.
      return payload.items ? payload.items[0] : payload;
    }

    // Capture phase, so the click is still recorded if a slider or the drawer stops it
    // from propagating.
    document.addEventListener(
      "click",
      function (event) {
        const $link =
          event.target instanceof Element &&
          event.target.closest('a[href*="/products/"]');

        if (!$link) return;

        const $placement = $link.closest("[data-nosto-ref]");
        const ref = $placement && campaignRef($placement);
        const handle = productHandle($link.href);

        if (!ref || !handle) return;

        try {
          sessionStorage.setItem(
            NOSTO_CLICK_REF_KEY,
            JSON.stringify({ ref: ref, handle: handle, ts: Date.now() })
          );
        } catch (error) {
          // Private browsing -- attribution is best effort.
        }
      },
      true
    );

    // Every add-to-cart in the theme except the cart drawer's own recommendation button
    // goes out as a jQuery request to /cart/add.js. That button records its own vp/cp
    // pair and uses fetch, so it never doubles up here.
    $(document).ajaxSuccess(function (event, xhr, settings) {
      if (!settings || String(settings.url).split("?")[0] !== "/cart/add.js") return;

      const stored = readClickRef();
      const line = stored && addedLine(xhr);

      if (!line || line.handle !== stored.handle) return;

      // Spend the ref before recording, so a second add of the same product cannot
      // record a second cp.
      clearClickRef();

      window.nostojs &&
        window.nostojs(function (api) {
          if (!api.recordAttribution) return;

          const attribution = api.recordAttribution({
            target: String(line.product_id),
            ref: stored.ref,
            type: "cp",
          });

          attribution &&
            typeof attribution.done == "function" &&
            attribution.done();
        });
    });
  };

  const productFeeds = () => {
    const $feeds = document.querySelectorAll(
      ".product-feed-list .nosto_element"
    );

    function startFeed($feed) {
      const $list = $feed.querySelector(".nosto-list");

      if (!$list)
        return setTimeout(function () {
          startFeed($feed);
        }, 500);

      $($list).slick({
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    console.log('PRODUCT FEED NOSTO LISTS', $feeds);

    [...$feeds].forEach(function ($feed) {
      startFeed($feed);
    });
  };

  const fixedEmailModal = () => {
    const $modal = document.querySelector(".fixed-email-modal-wrapper");
    const $closer = $modal.querySelector("#fixed-close");

    $closer.addEventListener("click", function (event) {
      $modal.style.display = "none";
      createCookie("JMKlaviyo", "closed");
    });

    if(!window.KlaviyoSubscribe) return setTimeout(fixedEmailModal, 1500);
    // Klaviyo attachment for the fixed modal.
    window.KlaviyoSubscribe.attachToForms("#email_signup_fixed_modal", {
      hide_form_on_success: true,
      success: function ($form) {
        createCookie("JMKlaviyo", "subscribed");
        $(".fixed-email-modal-wrapper").hide();
        // $('.klaviyo_field_group.select-date-widget').hide();
      },
    });

    if (!readCookie("JMKlaviyo")) {
      $modal.style.display = "block";
    }
  };

  const footer = () => {
    const $chatTriggers = document.querySelectorAll(".chat-trigger");

    if ($chatTriggers.length) {
      $chatTriggers.forEach(trigger => {
        trigger.addEventListener("click", function (event) {
          event.preventDefault();
          // tidioChatApi.popUpOpen();
          if(GorgiasChat && typeof GorgiasChat.open === 'function') GorgiasChat.open();
        });
      })
    }
  };

  function getCartPromise() {
    return new Promise(function (resolve, reject) {
      JM.MiniCart.getCart(function (cart) {
        resolve(cart);
      });
    });
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  $(document).on(
    "click",
    ".nosto-cart-wrapper .nosto-btn",
    async function (event) {
      let $btn = event.currentTarget;
      let $item = $btn.closest(".nosto-list-item");
      let $items = $item.parentElement.querySelectorAll(".nosto-list-item");

      let $nextItem = [...$items].find(function ($nosto, index) {
        return (
          $nosto !== $item &&
          index > 1 &&
          $nosto.style.display !== "none" &&
          $nosto.style.display !== "flex"
        );
      });

      console.log("Button Click?", { $btn });

      $item.style.display = "none";
      $nextItem.style.display = "flex";
      await sleep(500);

      let cart = await getCartPromise();

      console.log("Update Nosto Cart", cart);

      JM.MiniCart.populateContainer(cart);

      setTimeout(init_cart_slider, 150);
    }
  );

  async function init_cart_slider() {
    let cart = await getCartPromise();

    let allFragrance = [...cart.items].every(
      (item) => item.handle.indexOf("fragrance") > -1
    );

    $(".product-slider").slick({
      dots: false,
      infinite: true,
      autoplay: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      nextArrow:
        '<span class="slide-arrow arrow-next"><i class="fa fa-angle-right"></i></span>',
      prevArrow:
        '<span class="slide-arrow arrow-prev"><i class="fa fa-angle-left"></i></span>',
    });

    const slickData = $(".product-slider").slick("getSlick");

    if (slickData.slideCount > 0) {
      $(".cart-upsell").removeClass("hide");
    }

    // Nosto Carousel
    setTimeout(() => {
      $("#nosto_cartdrawer .nosto-list").slick({ slidesToShow: 2 });
      setTimeout(() => {
        $("#nosto_cartdrawer .nosto-list").slick("setPosition");
      }, 150);
    }, 750);

    if (document.querySelector("#cart-preview-dropdown .cart-note"))
      document.querySelector(
        "#cart-preview-dropdown .cart-note"
      ).style.display = allFragrance ? "none" : "block";
    console.log("Slick Test", $(".product-slider").slick("getSlick"), cart);
  }

  $("#ajax-trigger").on("click", function (e) {
    e.preventDefault();
    //   donation_added();
    $("#cart-preview-dropdown").toggleClass("is-open");
    init_cart_slider();
    // Refresh only this dropdown's placement. loadRecommendations() used to be called
    // here, but it replays the full page context -- tagging and VP events included --
    // on every click, which is what Nosto flagged (Ben Bradley, 2026-08-05).
    // No setRefs(): this must refresh the placement without recording attribution.
    nostojs(function (api) {
      if (typeof api.createRecommendationRequest === "function") {
        api.createRecommendationRequest().setElements(["nosto_cartdrawer"]).load();
      }
    });
  });

  /***********Close Cart on click close icon*************/
  $("body").on("click", ".cart-close", function (e) {
    $("#cart-preview-dropdown").removeClass("is-open");
  });
  /***********Close Cart on click close icon*************/

  // First: fixedEmailModal() below throws on any page without .fixed-email-modal-wrapper,
  // which kills everything after it in this IIFE. Attribution must not depend on that.
  nostoAttribution();
  footer();
  // The homepage Nosto feed sliders also go before it: with the modal section commented
  // out of theme.liquid, nothing after fixedEmailModal() runs and the feeds never scroll.
  productFeeds();
  fixedEmailModal();
  headerHandlers();
  console.log('Layout JS');
})();
